module.exports = __webpack_public_path__ + "static/media/icon-cross.2c8220bb.svg";